import { create } from 'zustand';
import type { ParsedOrder, RawOrderRow } from '@shipping/core';

interface FieldMapping {
  originCity: string | null;
  destinationAddress: string | null;
  estimatedWeight: string | null;
  productCategory: string | null;
  currentCourier: string | null;
}

interface OrderState {
  rawHeaders: string[];
  rawPreview: Record<string, unknown>[];
  fieldMapping: FieldMapping;
  totalRows: number;
  validRows: number;
  errorRows: number;
  parsedOrders: ParsedOrder[];
  fileName: string | null;

  setRawData: (headers: string[], preview: Record<string, unknown>[], totalRows: number) => void;
  setFieldMapping: (mapping: Partial<FieldMapping>) => void;
  setValidation: (valid: number, errors: number) => void;
  setParsedOrders: (orders: ParsedOrder[]) => void;
  setFileName: (name: string) => void;
  reset: () => void;
}

const EMPTY_MAPPING: FieldMapping = {
  originCity: null,
  destinationAddress: null,
  estimatedWeight: null,
  productCategory: null,
  currentCourier: null,
};

export const useOrderStore = create<OrderState>((set) => ({
  rawHeaders: [],
  rawPreview: [],
  fieldMapping: EMPTY_MAPPING,
  totalRows: 0,
  validRows: 0,
  errorRows: 0,
  parsedOrders: [],
  fileName: null,

  setRawData: (headers, preview, totalRows) =>
    set({ rawHeaders: headers, rawPreview: preview, totalRows }),
  setFieldMapping: (mapping) =>
    set((state) => ({ fieldMapping: { ...state.fieldMapping, ...mapping } })),
  setValidation: (valid, errors) => set({ validRows: valid, errorRows: errors }),
  setParsedOrders: (orders) => set({ parsedOrders: orders }),
  setFileName: (name) => set({ fileName: name }),
  reset: () =>
    set({
      rawHeaders: [],
      rawPreview: [],
      fieldMapping: EMPTY_MAPPING,
      totalRows: 0,
      validRows: 0,
      errorRows: 0,
      parsedOrders: [],
      fileName: null,
    }),
}));
